import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { Store } from '@ngrx/store';

@Component({
  selector: 'app-search-navbar-base-subform',
  templateUrl: './search-navbar-base-subform.component.html',
  styleUrls: ['./search-navbar-base-subform.component.scss'],
})
export abstract class SearchNavbarBaseSubformComponent implements OnInit {
  @Input() title!: string;
  @Input() filterUpdater!: any;
  @Input() storedFilterSelector!: any;
  @Input() canStoreFilter?: boolean;
  @Input() property!: string;
  @Input() data?: any;

  group = this.fb.group({});

  constructor(readonly store: Store, readonly fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    if (this.canStoreFilter) {
      this.store.select(this.storedFilterSelector).subscribe((storedFilter) => {
        this.clear();
        this.updateValue(storedFilter);
      });
    }
  }

  abstract updateValue(filter?: any): void;

  clear(): void {
    this.group.reset();
  }
}
